import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AdminLogin } from '../components/admin/AdminLogin';
import { BookingsList } from '../components/admin/BookingsList';
import { useBookings } from '../hooks/useBookings';
import { Button } from '../components/ui/Button';
import { LogOut, LayoutDashboard } from 'lucide-react';
export function AdminDashboard() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const {
    bookings,
    deleteBooking
  } = useBookings();
  if (!isAuthenticated) {
    return <div className="min-h-screen bg-gray-50 p-4" data-id="element-116">
        <Link to="/" className="absolute top-4 left-4 text-gray-500 hover:text-gray-900" data-id="element-117">
          ← Back to Home
        </Link>
        <AdminLogin onLogin={() => setIsAuthenticated(true)} data-id="element-118" />
      </div>;
  }
  return <div className="min-h-screen bg-gray-50" data-id="element-119">
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-10" data-id="element-120">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between" data-id="element-121">
          <div className="flex items-center gap-2 font-bold text-gray-900 text-lg" data-id="element-122">
            <LayoutDashboard className="w-5 h-5 text-blue-600" data-id="element-123" />
            Admin Dashboard
          </div>
          <div className="flex items-center gap-4" data-id="element-124">
            <Link to="/" className="text-sm text-gray-500 hover:text-gray-900" data-id="element-125">
              View Site
            </Link>
            <Button variant="outline" size="sm" onClick={() => setIsAuthenticated(false)} data-id="element-126">
              <LogOut className="w-4 h-4 mr-2" data-id="element-127" />
              Logout
            </Button>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-128">
        <div className="mb-8" data-id="element-129">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-130">Manage Bookings</h1>
          <p className="text-gray-600 mt-1" data-id="element-131">
            View and manage all scheduled meetings for PTC 2026.
          </p>
        </div>

        <BookingsList bookings={bookings} onDelete={deleteBooking} data-id="element-132" />
      </main>
    </div>;
}